import { Injectable } from '@angular/core';
import { ApolloClient, InMemoryCache, HttpLink, split } from '@apollo/client/core';
import { getMainDefinition } from '@apollo/client/utilities';
import { createClient } from 'graphql-ws';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { environment } from '../../../environments/environment';

@Injectable()
export class ApolloConfigService {
  public apolloClient: ApolloClient<any>;

  constructor() {
    this.createApolloClient();
  }

  private createApolloClient() {
    const httpLink = new HttpLink({
      uri: environment.telemetryServiceUrl + 'real-time/graphql',
    });

    const wsLink = new GraphQLWsLink(
      createClient({
        url: environment.telemetryUrlWS + 'real-time/graphql-ws',
        connectionParams: {
          reconnect: true,
          connectionParams: {},
        },
      })
    );

    const link = split(
      ({ query }) => {
        const definition = getMainDefinition(query);
        return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
      },
      wsLink,
      httpLink
    );

    this.apolloClient = new ApolloClient({
      link,
      cache: new InMemoryCache(),
    });
  }
}
